import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { getFavoriteKeywords } from '../../api/product'
import { colorObj } from '../../components/color'
import { delAllRecentlySearchWord, delRecentlySearchWord, setRecentlySearchWord } from '../../js/script'
import { imgURL } from '../Home'

export default function SearchHeader({
  keyword,
  setKeyword,
  filterSearch,
  setSearchKeyword,
}: {
  keyword: string
  setKeyword: React.Dispatch<React.SetStateAction<string>>
  filterSearch: any
  setSearchKeyword: React.Dispatch<React.SetStateAction<any>>
  setIsSearch?: React.Dispatch<React.SetStateAction<any>>
}) {
  const [recentKeyword, setRecentKeyword] = useState<any>()
  const [deleteRecent, setDeleteRecent] = useState<any>()
  const [popularSearch, setPopularSearch] = useState<string[]>([])
  const navigate = useNavigate()

  useEffect(() => {
    if (window.localStorage.getItem('recentlySearchWord')) {
      const recent: any = window.localStorage.getItem('recentlySearchWord')
      const recentParse = JSON.parse(recent)
      setRecentKeyword(recentParse)
    } else {
      setRecentKeyword([])
    }
  }, [deleteRecent])

  useEffect(() => {
    getFavoriteKeywords()
      .then((res) => setPopularSearch(res.data))
      .catch((err) => console.log(err))
  }, [])

  return (
    <>
      {keyword === '' ? (
        <div className='search_result_wrap'>
          <div className='recent_search'>
            <div className='title'>
              <p>최근 검색어</p>
              {recentKeyword?.length !== 0 ? (
                <button
                  onClick={() => {
                    delAllRecentlySearchWord()
                    setDeleteRecent((prev: boolean) => !prev)
                  }}
                >
                  전체삭제
                </button>
              ) : null}
            </div>
            <div className='result'>
              {recentKeyword?.length === 0 ? (
                <div className='no_data'>최근 검색어가 없습니다.</div>
              ) : (
                <div className='keyword'>
                  {recentKeyword?.map((el: string) => {
                    return (
                      <div key={el} className='recent_keyword_item'>
                        <button
                          onClick={() => {
                            navigate(`/search/searchResult?keyword=${el}`)
                            setRecentlySearchWord(el)
                          }}
                        >
                          {el}
                        </button>
                        <img
                          src={`${imgURL}/icon_close_gray.png`}
                          alt='닫기 버튼'
                          onClick={() => {
                            delRecentlySearchWord(el)
                            setTimeout(() => {
                              setDeleteRecent((prev: boolean) => !prev)
                            }, 200)
                          }}
                        />
                      </div>
                    )
                  })}
                </div>
              )}
            </div>
          </div>
          <div className='trend_search'>
            <div className='title'>
              <p>인기 검색어</p>
            </div>
            <div className='result'>
              <div className='list_wrap'>
                <ul>
                  {popularSearch?.slice(0, 5)?.map((el: string, idx: number) => {
                    return (
                      <li
                        key={idx}
                        onClick={() => {
                          setRecentlySearchWord(el)
                          navigate(`/search/searchResult?keyword=${el}`)
                        }}
                      >
                        <span className={idx <= 2 ? 'top' : ''}>{idx + 1}</span>
                        {el}
                      </li>
                    )
                  })}
                </ul>
                <ul>
                  {popularSearch?.slice(5, 10)?.map((el: string, idx: number) => {
                    return (
                      <li
                        key={idx}
                        onClick={() => {
                          setRecentlySearchWord(el)
                          navigate(`/search/searchResult?keyword=${el}`)
                        }}
                      >
                        <span>{idx + 6}</span>
                        {el}
                      </li>
                    )
                  })}
                </ul>
              </div>
            </div>
          </div>
        </div>
      ) : (
        <div className='auto_complete'>
          <div className='list'>
            <ul>
              {filterSearch?.map((el: any, index: number) => {
                const firstEIndex = el.productName.indexOf(keyword)
                const keywordLength = keyword.length
                const beforeE = el.productName.slice(0, firstEIndex)
                const afterE = el.productName.slice(firstEIndex + keywordLength)

                return (
                  <li key={`${el.id}-${index}`}>
                    <a
                      href='#'
                      key={el.productNo}
                      onClick={(e) => {
                        e.preventDefault()
                        navigate(`/search/searchResult?keyword=${el.productName}`)
                        setKeyword('')
                        setRecentlySearchWord(el.productName)
                        // setIsSearch(false);
                        // setIsSearchContainer(false);
                        setSearchKeyword('')
                      }}
                    >
                      {beforeE}
                      <span style={{ color: colorObj.colPointBlue }}>{keyword}</span>
                      {afterE}
                    </a>
                  </li>
                )
              })}
            </ul>
          </div>
        </div>
      )}
    </>
  )
}
